import { Outlet } from "react-router-dom";

export const NoNavBarLayout = () => {
  return (
    <div className="pt-header-height pb-safe">
      <Outlet />
    </div>
  );
};
